import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { string, bool, shape, func } from 'prop-types'
// import yn from 'yn'
import { selectModifyFlowType } from '../../redux/modifyBooking/selectors'
import { renderFormFields } from '../../redux/configuration/utilities'
import { EDLAcceptedStates, getFieldsAndLayout } from './utilities'
import { ModifyFlowType } from '../../configuration/constants'
import './PassengerForm.scss'
import Modal from '../Modal'
import { capitalizeFirstLetter } from '../../configuration/utilities'
import SvgIcon from '../SvgIcon/SvgIcon'

const PassengerForm = ({
  fieldDetails,
  disabled,
  values,
  rowLabels,
  setFieldValue,
  formRowClasses,
  errorClasses,
  parentKey,
  paymentFerryId,
  onBlur,
  labels
}) => {
  const [openEdlModal, setOpenEdlModal] = useState(false)
  const [openBirthCertificateModal, setOpenBirthCertificateModal] = useState(
    false
  )
  const [issueingState, setIssueingState] = useState('')
  const prevTypeRef = useRef({})
  const hasInitRef = useRef(false)
  const modifyFlowType = useSelector(selectModifyFlowType)
  const { mainLayout /* , optionalLayout */ } = getFieldsAndLayout({
    paymentFerryId
  })

  useEffect(() => {
    if (!hasInitRef?.current) {
      Object.keys(values).forEach(passengerId => {
        prevTypeRef.current[passengerId] = values[passengerId]?.typeOfId
      })
      hasInitRef.current = true
      return
    }
    Object.keys(values).forEach(passengerId => {
      const currentType = values[passengerId]?.typeOfId
      const prevType = prevTypeRef?.current[passengerId]
      if (currentType && currentType !== prevType) {
        //type D for EDL- enhanced drivers license
        if (currentType === 'D') {
          setOpenEdlModal(true)
          //type B for birth certificate
        } else if (currentType === 'B') {
          setOpenBirthCertificateModal(true)
        }
      }
      prevTypeRef.current[passengerId] = currentType
    })
  }, [values])

  let previousPassengerType = null
  return !fieldDetails || !values ? null : (
    <>
      <Fragment>
        {Object.keys(values).map(passengerId => {
          const passengerValue = values[passengerId]
          const renderDivider =
            passengerValue.type === 'returns' &&
            previousPassengerType === 'departures' &&
            modifyFlowType !== ModifyFlowType.DEPARTURE_LOCKED
          previousPassengerType = passengerValue.type

          if (
            modifyFlowType === ModifyFlowType.DEPARTURE_LOCKED &&
            passengerValue.type === 'departures'
          ) {
            return null
          }

          return (
            <Fragment key={passengerId}>
              {renderDivider && (
                <div className="rule-container">
                  <hr />
                </div>
              )}
              {rowLabels?.[passengerId] && (
                <span className={formRowClasses}>
                  <span className="row-label theme-title-variant capitalize">
                    {rowLabels[passengerId]}
                  </span>
                </span>
              )}
              {renderFormFields({
                formLayout: mainLayout,
                fieldDetails,
                disabled,
                values: passengerValue,
                setFieldValue,
                formRowClasses,
                errorClasses,
                parentKey: parentKey
                  ? `${parentKey}.${passengerId}`
                  : passengerId,
                onBlur,
                labels
              })}
            </Fragment>
          )
        })}
      </Fragment>
      <Modal
        isOpen={openEdlModal}
        onRequestClose={() => setOpenEdlModal(false)}
        className="passenger-modal-container"
      >
        <div className="passenger">
          <div
            className="passenger__close"
            onClick={() => setOpenEdlModal(false)}
          >{`${capitalizeFirstLetter(labels.close)} X`}</div>
          <div className="passenger__content">{labels?.selectEDL}</div>
          <div className="passenger__option">
            <select
              className={`passenger__select ${
                issueingState ? '' : 'is-placeholder'
              }`}
              value={issueingState}
              onChange={event => setIssueingState(event.target.value)}
            >
              <option value="" disabled>
                {labels?.enterIssuingState}
              </option>
              {EDLAcceptedStates.map(val => (
                <option key={val} value={val}>
                  {val}
                </option>
              ))}
            </select>
            <SvgIcon type="dropdown" className="passenger__option__dropdown" />
          </div>

          <button
            className="btn btn-primary passenger__button"
            disabled={!issueingState}
            onClick={() => {
              setOpenEdlModal(false)
            }}
          >
            <span className="passenger__save">
              {labels?.continueToTripSummary}
            </span>
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={openBirthCertificateModal}
        onRequestClose={() => setOpenBirthCertificateModal(false)}
        className="passenger-modal-container"
      >
        <div className="passenger">
          <div
            className="passenger__close"
            onClick={() => setOpenBirthCertificateModal(false)}
          >{`${capitalizeFirstLetter(labels.close)} X`}</div>
          <div
            className="passenger__content"
            dangerouslySetInnerHTML={{
              __html: labels?.youngTravellerCredentials
            }}
          />
          <button
            className="btn btn-primary passenger__button"
            onClick={() => {
              setOpenBirthCertificateModal(false)
            }}
          >
            <span className="passenger__save">
              {labels?.continueToTripSummary}
            </span>
          </button>
        </div>
      </Modal>
    </>
  )
}

PassengerForm.propTypes = {
  fieldDetails: shape().isRequired,
  disabled: bool,
  values: shape().isRequired,
  rowLabels: shape().isRequired,
  setFieldValue: func.isRequired,
  formRowClasses: string.isRequired,
  errorClasses: string.isRequired,
  parentKey: string,
  paymentFerryId: string.isRequired,
  labels: shape().isRequired
}

PassengerForm.defaultProps = {
  disabled: false,
  parentKey: 'passengerDetails'
}

export default PassengerForm
